module.exports = __webpack_public_path__ + "img/upgrade.c49724e5.svg";